import React from "react";
import { SnackbarProvider } from "notistack";
import RisImportComponent from "../risImportComponent";

const RisImport = () => {
  return (
    <SnackbarProvider maxSnack={3} autoHideDuration={3000}>
      <div className="main-wrapper">
        <div className="content-wrapper">
          <RisImportComponent />
        </div>
      </div>
    </SnackbarProvider>
  );
};

export default RisImport;
